import { styled } from "@openteam/design-system";

export default styled('hr')(({ theme }) => ({
  flex: 1,
  height: 1,
  border: 'none',
  backgroundColor: theme.palette.secondary.main
}))
